<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)">
				<van-icon name="arrow-left"/>
			</div>
			<div class="big_tit">{{ $t('lang.充提记录') }}</div>
		</div>
		<div class="cont">
			<div class="tab">
				<div class="tab-item" :class="{ 'active': curTabIndex === 1 }" @click="changeTab(1)">{{ $t('user.rechargeRecord') }}</div>
				<div class="tab-item" :class="{ 'active': curTabIndex === 2 }" @click="changeTab(2)">{{ $t('user.withdrawalRecord') }}</div>
			</div>
			
			<div class="list">
				<van-empty :description="$t('item.noData')" v-if="listShow"/>
				<div class="item" v-for="item in list">
					<div class="de_wrap">
						<p class="tit">{{ item.type || item.bank }}</p>
						<p class="time" v-if="item.account">{{ $t('invest_qrcode.address') }}</p>
						<p class="time">{{ item.time }}</p>
					
					</div>
					<div class="price">
						<span :class="item.type?'':'del'">{{
								item.type ? $t('utils.moneyMark') + parseInt(item.money) : '-' + $t('utils.moneyMark') + parseInt(item.money)
							}}</span>
						<div class="status" v-if="item.account">{{ item.account }}</div>
						<div class="status">{{ map[item.status] }}: {{ item.remark }}</div>
					</div>
				
				</div>
			</div>
		
		</div>
	</div>
</template>


<script>
import Fetch from '@/utils/fetch';

export default {
	name: "history",
	data() {
		return {
			lang: this.$i18n.locale || "en_us",
			curTabIndex: 1,
			list: [],
			map: {
				0: this.$t('lang.审核中'),
				1: this.$t('lang.审核成功'),
				2: this.$t('lang.审核失败'),
				3: this.$t('lang.待提交'),
			}
		}
	},
	created() {
		this.$parent.footer('', false)
		this.getList();
	},
	methods: {
		changeTab(index) {
			this.curTabIndex = index;
			this.getList();
		},
		getList() {
			Fetch('/user/funds', {
				reason_id: this.curTabIndex
			}).then(r => {
				this.list = r.data.list;
			})
		}
	}
}
</script>


<style scoped lang="less">
.basic_wrap {
	height: 100vh;
	
	.red_top_bg {
		background: rgb(35, 29, 29) !important;
		color: rgb(239, 216, 196) !important;
		
		.back_left {
			color: rgb(239, 216, 196) !important;
		}
		
		.big_tit {
			color: rgb(239, 216, 196) !important;
		}
	}
	
	.cont {
		height: calc(100vh - 46px);
		background: url('../../assets/img/home-bg.jpg') repeat center;
		background-size: 100%;
		padding: 12px;
		overflow-y: scroll;
		
		.tab {
			display: flex;
			align-items: center;
			justify-content: space-evenly;
			
			.tab-item {
				background-color: #4d4141;
				width: 9rem;
				height: 2.15625rem;
				border-radius: 0.21875rem;
				color: #e6dada;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: .75rem;
			}
			
			.active {
				color: #311500;
				background: linear-gradient(0deg, #B08868 1%, #B08868 21%, #F5E6DD 100%);
			}
		}
	}
}

.list {
	width: 96%;
	margin-left: 2%;
	border-radius: 6px;
	margin-top: 10px;
	
	.item {
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 8px;
		border: 1px solid #917E70;
		border-radius: 0.59375rem;
		background: #4B4241;
		color: #f5e7db;
		
		.de_wrap {
			flex: 2;
			
			.tit {
				font-size: 14px;
				line-height: 20px;
				font-weight: bold;
			}
			
			.time {
				font-size: 12px;
				line-height: 17px;
				margin-top: 10px;
			}
		}
		
		.price {
			flex: 1;
			font-size: 18px;
			line-height: 28px;
			font-weight: bold;
			text-align: right;
			color: #f5e7db;
			white-space: nowrap;
			
			&.del {
				color: #3FAF3E;
			}
			
			.status {
				font-size: .8rem !important;
			}
		}
	}
}
</style>
